(function(){"use strict";try{if(typeof document<"u"){var e=document.createElement("style");e.appendChild(document.createTextNode("._197huqt0{scroll-snap-type:x mandatory;scroll-behavior:smooth;user-select:none;-webkit-user-select:none;display:flex;overflow-x:auto;width:100%;height:100%;flex-flow:row nowrap;scrollbar-width:none}._197huqt0::-webkit-scrollbar{display:none}._197huqt1{scroll-snap-type:none;scroll-behavior:auto}._197huqt0>*{scroll-snap-align:center;width:100%;height:100%;flex:none}")),document.head.appendChild(e)}}catch(o){console.error("vite-plugin-css-injected-by-js",o)}})();
import R, { useRef as l, useEffect as D, useCallback as c } from "react";
var W = "_197huqt0", u = "_197huqt1";
const b = ({
  index: a,
  onChangeIndex: f,
  className: L = "",
  children: v
}) => {
  const i = l(!0), r = l(null), s = l(null), o = l(!1);
  D(() => {
    if (!r.current)
      return;
    const e = i.current;
    i.current = !1;
    const t = r.current.offsetWidth, n = a * t;
    r.current.scrollLeft !== n && (e ? r.current.classList.add(u) : (
      // Skip handling the scroll event. for example, does not fire changing to index 2 when the index changes from 1 to 3.
      o.current = !0
    ), r.current.scrollLeft = n);
  }, [a]);
  const M = c(
    (e) => {
      if (o.current || !r.current)
        return;
      const t = r.current.offsetWidth, n = e.currentTarget.scrollLeft;
      n % t === 0 && (r.current.classList.remove(u), f(n / t));
    },
    [a, f]
  ), m = c(() => {
    o.current = !1;
  }, []), p = c((e) => {
    Math.abs(e.deltaX) !== 0 && (o.current = !1);
  }, []), w = c(
    (e) => {
      r.current && (r.current.classList.add(u), s.current = r.current.scrollLeft + e.pageX);
    },
    []
  ), S = c(
    (e) => {
      r.current && s.current && (r.current.scrollLeft = s.current - e.pageX, e.preventDefault());
    },
    []
  ), d = c(() => {
    if (!(r.current && s.current))
      return;
    const e = r.current.offsetWidth, t = r.current.scrollLeft, h = Math.trunc((t + e / 2) / e) * e;
    t === h && r.current.classList.remove(u), r.current.scrollTo({
      left: h,
      behavior: "smooth"
    }), s.current = null;
  }, []);
  return /* @__PURE__ */ R.createElement(
    "div",
    {
      className: `${W} ${L}`,
      ref: r,
      onScroll: M,
      onWheel: p,
      onPointerDown: m,
      onMouseDown: w,
      onMouseMove: S,
      onMouseUp: d,
      onMouseLeave: d
    },
    v
  );
};
export {
  b as Carousel
};
